// Google Maps API key used by the browser-based Maps and geocoding features.
// This key is intentionally client-side and must be restricted by referrer in
// Google Cloud Console.
const GOOGLE_MAPS_API_KEY = 'AIzaSyC7x0-9jytT7aj6k5ZdFQzn7XNQuwSEiAw'

let isScriptLoaded = false
let isScriptLoading = false
let scriptLoadPromise: Promise<void> | null = null

export function isGoogleMapsScriptLoaded(): boolean {
  return isScriptLoaded
}

export function isGoogleMapsScriptLoading(): boolean {
  return isScriptLoading
}

export function loadGoogleMapsScript(): Promise<void> {
  if (isScriptLoaded) {
    return Promise.resolve()
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise
  }

  isScriptLoading = true

  scriptLoadPromise = new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- defensive guard, google maps may not be loaded
    if (window.google?.maps) {
      isScriptLoaded = true
      isScriptLoading = false
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=__googleMapsCallback`
    script.async = true
    script.defer = true

    ;(window as unknown as { __googleMapsCallback: () => void }).__googleMapsCallback = () => {
      isScriptLoaded = true
      isScriptLoading = false
      resolve()
    }

    script.onerror = () => {
      isScriptLoading = false
      scriptLoadPromise = null
      reject(new Error('Failed to load Google Maps script'))
    }

    document.head.appendChild(script)
  })

  return scriptLoadPromise
}
